import Env from "../env/Env";
import createAxiosInstance from "../utils/axiosInstance";
import { defaultAPIsResponseType, defaultGraphsGetFiltersType } from "../consts/shared";

const basePath = '/api/graphs/dashboard-1';

const request = createAxiosInstance(`${Env.API_BASE}${basePath}`);

const dashboard1APIsService = {
  basePath,
  fetchMostLeastCompliantCoursesData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/most-least-compliant-courses", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },

  fetchOrganisationsByComplianceGroupData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/organisations-by-compliance-group", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },

  fetchUsersByComplianceGroupData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/users-by-compliance-group", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },

  fetchNewUsersPerMonthData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/new-users-per-month", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },

  fetchMonthlyUserActivityData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/monthly-user-activity", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },

  fetchMostLeastCompliantOrganisationsData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/most-least-compliant-organisations", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },

  fetchMostLeastCompliantRolesData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/most-least-compliant-roles", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },

  fetchMostLeastCompliantSitesData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/most-least-compliant-sites", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },

  fetchOrganisationCourseSummaryData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/organisation-course-summary", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },

  fetchSummaryCardsData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/summary-cards", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },

  fetchOrganisationCourseSummaryDrillDown: (organisationId: number, params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get(`/organisation-course-summary-drilldown/${organisationId}`, { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },

  fetchMiReportData: (params: defaultGraphsGetFiltersType, signal?: AbortSignal): Promise<defaultAPIsResponseType> => {
    return new Promise((resolve, reject) => {
      request
        .get("/mi-report", { params, signal })
        .then(({ data }) => {
          resolve({ ...data, ...params });
        })
        .catch((err) => {
          reject(err?.response?.data?.errors || []);
        });
    });
  },
};

export default dashboard1APIsService;
